import {SYSTEM_MEASURE} from './SystemMeasure';

export const ONE_METER_IN_FEET = 3.28084;
export const ONE_MILE_IN_KM = 1.609344;
export const KM_IN_MILES = 0.621371;
export const ONE_HOUR_TO_SECONDS = 3600;
export const ONE_KM_IN_METERS = 1000;
export const ONE_FEET_TO_METERS = 0.3048;

/*
* The value of 255 meters for the forward distance is the upper limit considered
* by the dvr and it represents an unknown value. The maximum value that should be
* displayed for users is 254 meters or its equivalent in feet.
*/
export const forwardDistanceLimit = systemMeasure => {
  return systemMeasure === SYSTEM_MEASURE.METRIC
    ? 255
    : 255 * ONE_METER_IN_FEET;
};

export const forwardSpeedLimit = systemMeasure => {
  return systemMeasure === SYSTEM_MEASURE.METRIC
    ? 255
    : 255 * KM_IN_MILES;
};

export const forwardSpeedMax = systemMeasure => {
  return systemMeasure === SYSTEM_MEASURE.METRIC
    ? 120 * ONE_MILE_IN_KM
    : 120;
};

export const initialForwardDistance = systemMeasure => {
  return systemMeasure === SYSTEM_MEASURE.METRIC
    ? 250
    : 250 * ONE_METER_IN_FEET;
};

/*
* The value of 127.5 miles per hour for the speed is a convention on the DVR
* that means the actual speed is unknown
*/
export const dvrUnknownSpeed = systemMeasure => {
  return systemMeasure === SYSTEM_MEASURE.METRIC
    ? 127.5 * ONE_MILE_IN_KM
    : 127.5;
};
